function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "research");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.279 3.279c2.026-2.026 4.825-3.279 7.916-3.279 6.183 0 11.196 5.012 11.196 11.196v0c0 0.010 0 0.021 0 0.032 0 2.751-1 5.269-2.656 7.209l0.013-0.015 2.264 2.264c0.411-0.216 0.897-0.342 1.414-0.342 0.852 0 1.623 0.345 2.182 0.902l5.492 5.492c0.558 0.558 0.903 1.329 0.903 2.181 0 1.703-1.381 3.084-3.084 3.084-0.852 0-1.623-0.345-2.181-0.903l-5.493-5.492c-0.558-0.559-0.903-1.331-0.903-2.183 0-0.516 0.127-1.003 0.35-1.43l-0.008 0.017-2.262-2.263c-1.936 1.644-4.464 2.644-7.226 2.644-6.183 0-11.195-5.012-11.196-11.195v-0c-0-0.009-0-0.020-0-0.030 0-3.082 1.254-5.871 3.279-7.886l0.001-0zM22.571 24.281l5.492 5.492c0.219 0.219 0.521 0.354 0.855 0.354 0.668 0 1.209-0.541 1.209-1.209 0-0.334-0.135-0.636-0.354-0.855l-5.492-5.492c-0.219-0.219-0.521-0.354-0.855-0.354-0.668 0-1.209 0.541-1.209 1.209 0 0.334 0.135 0.636 0.354 0.855v0zM4.605 17.786c1.687 1.687 4.017 2.73 6.59 2.73 5.147 0 9.32-4.173 9.32-9.32 0-2.574-1.043-4.904-2.73-6.59v0c-1.687-1.687-4.017-2.73-6.59-2.73-5.147 0-9.32 4.173-9.32 9.32 0 2.574 1.043 4.904 2.73 6.59v0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.946 11.257c0.518 0 0.937 0.42 0.937 0.937v0 3c0 0.518-0.42 0.937-0.937 0.937s-0.937-0.42-0.937-0.937v0-3c0-0.518 0.42-0.937 0.937-0.937v0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.821 8.132c0.518 0 0.937 0.42 0.937 0.937v0 6.125c0 0.518-0.42 0.937-0.937 0.937s-0.937-0.42-0.937-0.937v0-6.124c0-0 0-0.001 0-0.001 0-0.518 0.42-0.937 0.937-0.937v0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.696 9.383c0.518 0 0.937 0.42 0.937 0.937v0 4.876c0 0.518-0.42 0.937-0.937 0.937s-0.937-0.42-0.937-0.937v0-4.875c0-0 0-0.001 0-0.001 0-0.518 0.42-0.937 0.937-0.937v0z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.57 6.257c0.518 0 0.937 0.42 0.937 0.937v0 8.001c0 0.518-0.42 0.937-0.937 0.937s-0.937-0.42-0.937-0.937v0-8c0-0 0-0.001 0-0.001 0-0.518 0.42-0.937 0.937-0.937v0z"
});

var SvgResearch = function SvgResearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/research.7fbdb799.svg";
export { ForwardRef as ReactComponent };